import { formatDefinition } from 'app/utils/tag-utils';
import { Linkrole } from 'entities/tag';

interface LinkroleLabelOpts {
  tagLanguage: string;
  alias?: string;
}

export function linkroleLabel(linkrole: Linkrole, opts: LinkroleLabelOpts): string {
  if (opts.alias && opts.alias.length > 0) {
    const { category, label } = formatDefinition(opts.alias);
    return category ? `[${category}] ${label}` : label;
  }
  const languageLabel = linkrole.labels?.[opts.tagLanguage] ?? linkrole.labels?.en;
  const { category, label } = formatDefinition(linkrole.definition ?? '', languageLabel);
  return category ? `[${category}] ${label}` : label;
}

export const LinkroleCell = ({ linkrole, tagLanguage, alias }: { linkrole: Linkrole | null; tagLanguage: string; alias?: string }) => {
  if (!linkrole) return null;
  return <span className="ai-modal__linkrole">{linkroleLabel(linkrole, { tagLanguage, alias })}</span>;
};
